module.exports = __webpack_public_path__ + "img/WarlockLord.47ff2a40.jpg";